<ng-template #loaderBlock>
  <app-loader></app-loader>
</ng-template>
<div class="promotion-wrapper">
  <app-grouped-bar-chart
    *ngIf="promotionProgression"
    [name]="'promotionProgression'"
    [data]="promotionProgression"
    [columns]="columns"
    [colors]="colors"
    [legends]="legends"
  ></app-grouped-bar-chart>
  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
